import main from "./main.json";
import common from "./common.json";
const en = {
  ...main,
  ...common,
};
export default en;
